"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const AbstractTimeExpressionParser_1 = require("../../../common/parsers/AbstractTimeExpressionParser");

class NLTimeExpressionParser extends AbstractTimeExpressionParser_1.AbstractTimeExpressionParser {
  primaryPrefix() {
    return "(?:(?:om)\\s*)?";
  }

  followingPhase() {
    return "\\s*(?:\\-|\\–|\\~|\\〜|om|\\?)\\s*";
  }

  primarySuffix() {
    return "(?:\\s*(?:uur))?(?!/)(?=\\W|$)";
  }

  extractPrimaryTimeComponents(context, match) {
    if (match[0].match(/^\s*\d{4}\s*$/)) {
      return null;
    }

    return super.extractPrimaryTimeComponents(context, match);
  }

}

exports.default = NLTimeExpressionParser;